import React, { ReactNode } from "react";
import { Box, ButtonBase, Grid, makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import { tesaBlue } from "../../../styles/colors";

const useStyles = makeStyles({
  close: {
    marginRight: -5,
  },
  text: {
    letterSpacing: 0.25,
    lineHeight: "1rem",
    fontSize: "0.875rem",
  },
  button: {
    color: tesaBlue,
    marginLeft: 30,
    letterSpacing: 0.25,
    lineHeight: "1rem",
    fontSize: "0.875rem",
    fontFamily: "Proxima Nova Bold",
  },
});

export interface ConfirmationDialogParams {
  headline?: string;
  text?: string | ReactNode;
  confirmText?: string;
  confirmColor?: string;
  hideCancel?: boolean;
  hideDefaultButton?: boolean;
  additionalAction?: {
    id: string;
    text: string;
    textColor?: string;
  };
}

export interface ConfirmationDialogProps extends ConfirmationDialogParams {
  open: boolean;
  onConfirm: (id: string) => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
  const classes = useStyles();
  const {
    open,
    onCancel,
    onConfirm,
    headline,
    text,
    confirmText,
    confirmColor,
    hideCancel,
    hideDefaultButton,
    additionalAction,
  } = props;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      {open && (
        <Box paddingX={3} paddingTop={2.5} paddingBottom={3}>
          <Box display="flex" justifyContent="space-between">
            <h6>{headline || "Are you sure?"}</h6>
            {!hideCancel && (
              <ButtonBase className={classes.close} onClick={onCancel}>
                <CloseIcon fontSize="small" />
              </ButtonBase>
            )}
          </Box>
          <Box paddingTop={1} paddingBottom={3} className={classes.text}>
            {text || ""}
          </Box>
          <Grid container justify="flex-end">
            {additionalAction && (
              <ButtonBase
                onClick={() => onConfirm(additionalAction?.id)}
                className={classes.button}
                style={additionalAction.textColor ? { color: additionalAction.textColor } : undefined}
              >
                {additionalAction.text}
              </ButtonBase>
            )}
            {!hideDefaultButton && (
              <ButtonBase
                onClick={() => onConfirm("DEFAULT")}
                className={classes.button}
                style={confirmColor ? { color: confirmColor } : undefined}
              >
                {confirmText || "Confirm"}
              </ButtonBase>
            )}
          </Grid>
        </Box>
      )}
    </Dialog>
  );
};

export default ConfirmationDialog;
